import {
	INVITATION_PRICING_PLANS_ENUM,
	INVITATION_STATUS,
	PRICING_PLAN_TYPE,
	TEMPLATES,
	TRANSACTION_TYPE_ENUM
} from "./store/services/invitations/dto/invitations.dto";
import { INVITATION_ORDER_STATUSES_ENUM } from "./store/services/orders/dto/orders.dto";
import { colors } from "@mui/material";

export const InvitationStatusColor = {
	[INVITATION_STATUS.DRAFT]: colors.grey[500],
	[INVITATION_STATUS.PENDING]: colors.orange[500],
	[INVITATION_STATUS.PUBLISHED]: colors.green[500],
	[INVITATION_STATUS.REJECTED]: colors.red[500],
	[INVITATION_STATUS.SUSPENDED]: colors.yellow[700],
	[INVITATION_STATUS.DELETED]: colors.red[700],
	[INVITATION_STATUS.ACTION_REQUIRED]: colors.orange[700]
};

export const DEFAULT_COORDINATES = {
	lat: 29.9759443,
	lng: 31.1321208
};

const DRAFT_MAX_MB = 2;
const ESSENTIAL_MAX_MB = 10;
const SIGNATURE_MAX_MB = 40;
const SIGNATURE_MAX_VIDEO_MB = 300;

export const PRICING_PLAN_CONFIG: Record<INVITATION_PRICING_PLANS_ENUM, PRICING_PLAN_TYPE> = {
	[INVITATION_PRICING_PLANS_ENUM.FREE]: {
		image_size: DRAFT_MAX_MB,
		gallery_media_count: 2,
		video_size: 0,
		is_guest_memory_enabled: false,
		memory_album_count: 0,
		memory_album_video_enabled: false,
		is_color_theme_enabled: false,
		description: "Get started for free — design your invitation and share it with your guests in minutes.",
		features: [
			"Create, customize & submit your invitation for review",
			"Review & Published within 48 hours",
			"Share via link, WhatsApp, Messenger & QR code",
			"Save-to-calendar for guests",
			"English & Arabic invitation support"
		]
	},
	[INVITATION_PRICING_PLANS_ENUM.ESSENTIAL]: {
		image_size: ESSENTIAL_MAX_MB,
		gallery_media_count: 10,
		video_size: 0,
		is_guest_memory_enabled: true,
		memory_album_count: 0,
		memory_album_video_enabled: false,
		is_color_theme_enabled: false,
		description:
			"Everything you need to create a stunning wedding invitation and track every RSVP — simple, elegant, and effortless.",
		features: [
			"Everything in Free",
			"Review & Published within 24 hours",
			"4 elegant color themes",
			"Multiple entrance themes",
			"RSVP management & guest confirmations",
			"Export RSVP responses to Excel",
			"Upload photos (up to 10MB per photo)",
			"Upload a gallery with up to 10 photos (up to 10MB per photo)"
		]
	},
	[INVITATION_PRICING_PLANS_ENUM.SIGNATURE]: {
		image_size: SIGNATURE_MAX_MB,
		gallery_media_count: 20,
		video_size: SIGNATURE_MAX_VIDEO_MB,
		is_guest_memory_enabled: true,
		memory_album_count: 10,
		memory_album_video_enabled: true,
		is_color_theme_enabled: true,
		description:
			"Elevate your wedding experience with premium customization, immersive memories, and exclusive VIP features.",
		features: [
			"Everything in Essential",
			"Priority Review & Publishing within 12 hours",
			"Detailed dashboard with real-time insights and spot-on statistics",
			"Push notifications across devices",
			"Private invitation with password protection",
			"Gallery upload of up to 20 photos or videos",
			"Guest memory album (up to 10 photos or videos per guest)",
			"High-quality uploads (up to 40MB per photo and 300MB per video)"
		]
	}
};

export const PLAN_NAMES = {
	[INVITATION_PRICING_PLANS_ENUM.FREE]: "Draft",
	[INVITATION_PRICING_PLANS_ENUM.ESSENTIAL]: "Essential",
	[INVITATION_PRICING_PLANS_ENUM.SIGNATURE]: "Signature"
};

export const TRANSACTION_TYPE: Record<TRANSACTION_TYPE_ENUM, string> = {
	[TRANSACTION_TYPE_ENUM.PAYMENT]: "Payment",
	[TRANSACTION_TYPE_ENUM.REFUND]: "Refund"
};

export const ORDER_TYPE: Record<INVITATION_ORDER_STATUSES_ENUM, string> = {
	[INVITATION_ORDER_STATUSES_ENUM.PENDING]: "Pending",
	[INVITATION_ORDER_STATUSES_ENUM.COMPLETED]: "Completed",
	[INVITATION_ORDER_STATUSES_ENUM.CANCELLED]: "Canceled",
	[INVITATION_ORDER_STATUSES_ENUM.FAILED]: "Failed"
};
